import { render, staticRenderFns } from "./PageResource.vue?vue&type=template&id=565a219d&scoped=true"
import script from "./PageResource.vue?vue&type=script&lang=js"
export * from "./PageResource.vue?vue&type=script&lang=js"
import style0 from "./PageResource.vue?vue&type=style&index=0&id=565a219d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "565a219d",
  null
  
)

export default component.exports